export default "__VITE_ASSET__eag5edat__"